import React from 'react'
import { globalState } from '../../store'
import { UserListPage } from '../../components/users'
import { useFetch } from '../../components/component-items/helpers'

export const CompanyUsers = () => {
  const {
    state: { csrf, companyId },
  } = globalState()

  // Fetch available roles for filtering
  const { response: rolesResp, loaded: rolesLoaded } = useFetch('/api/rbac/roles/?user_type=merchant', {})
  const roles =
    rolesLoaded && rolesResp?.results
      ? [...rolesResp.results]
          .sort((a: any, b: any) => b.level - a.level)
          .map((r: any) => ({ id: r.id, name: r.name, level: r.level }))
      : []

  return (
    <UserListPage
      userType="merchant"
      title="Company Users"
      companyId={companyId}
      csrf={csrf}
      permissionsBasePath="/company/users"
      roles={roles}
    />
  )
}
